<div *ngIf="show"
     (click)="onClick($event)"
     class="wavelength-overlay">
</div>